import { useEffect } from 'react'
import { useParams, useSearchParams } from 'react-router-dom'

import { Card, Link, Table, Text, Icon } from '@/ui'
import { fetchUserTransactions } from '@/features/transactions/transactions.slice'
import { fetchTransactionCategoriesIfNeeded } from '@/features/reports/reports.slice'
import { UserViewOnlyTransactionRow } from '@/components/UserViewOnlyTransactionRow'
import { getTransactionCategorySelector } from '@/features/reports/reports.selectors'
import { useReselector } from '@/utils/sharedHooks'
import { selectTransactionsByCategoryAndYear } from '@/features/transactions/transactions.selectors'
import { useAppDispatch } from '@/utils/typeHelpers'
import { TypographyStyles } from '@/styles'
import { faChevronLeft } from '@fortawesome/pro-solid-svg-icons'
export const UserTransactionsByCategory = () => {
  const dispatch = useAppDispatch()
  const { transactionCategoryId } = useParams()
  const [searchParams] = useSearchParams()

  const transactions = useReselector(
    selectTransactionsByCategoryAndYear,
    transactionCategoryId,
    searchParams.get('year') || 'all'
  )
  const category = useReselector(
    getTransactionCategorySelector,
    transactionCategoryId
  )

  useEffect(() => {
    dispatch(fetchTransactionCategoriesIfNeeded())
    dispatch(fetchUserTransactions())
  }, [dispatch])

  return (
    <div className="w-full">
      <Card>
        <Text variant={TypographyStyles.H2}>
          Expenses Transactions for: {category?.name}
        </Text>
        <Link
          href="/trends/expenses"
          newPage={false}
          className="my-2 mx-0 mb-1 w-fit font-semibold"
        >
          <Icon icon={faChevronLeft} className="flex items-center ml-1" />
          Back to Expenses Breakdown
        </Link>
        <Table className="bg-neutral-0">
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell className="w-2/12">Date</Table.HeaderCell>
              <Table.HeaderCell className="w-6/12">
                Description
              </Table.HeaderCell>
              <Table.HeaderCell className="w-2/12 text-right">
                Amount
              </Table.HeaderCell>
              <Table.HeaderCell className="w-6/12">Category</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {transactions.map((transaction) => (
              <UserViewOnlyTransactionRow
                key={transaction.id}
                transaction={transaction}
              />
            ))}
          </Table.Body>
        </Table>
      </Card>
    </div>
  )
}
